module.exports = __webpack_public_path__ + "img/whiteStar.cb807cd6.svg";